import { createTheme, alpha } from "@mui/material/styles";

const palette = {
  mode: "light",
  primary: {
    main: "#2563eb",
    light: "#60a5fa",
    dark: "#1d4ed8",
    contrastText: "#ffffff",
  },
  secondary: {
    main: "#0f172a",
    light: "#475569",
    dark: "#020617",
    contrastText: "#ffffff",
  },
  background: {
    default: "#f8fafc",
    paper: "#ffffff",
  },
  text: {
    primary: "#0f172a",
    secondary: "#64748b",
  },
  success: { main: "#10b981" },
  warning: { main: "#f59e0b" },
  error: { main: "#ef4444" },
  info: { main: "#0ea5e9" },
  divider: "rgba(15, 23, 42, 0.08)",
};

export const theme = createTheme({
  palette,
  typography: {
    fontFamily: "'Inter', sans-serif",
    fontSize: 12,
    h1: { fontWeight: 800, letterSpacing: "-0.02em" },
    h2: { fontWeight: 800, letterSpacing: "-0.02em" },
    h3: { fontWeight: 700, letterSpacing: "-0.02em" },
    h4: { fontWeight: 700, letterSpacing: "-0.02em" },
    h5: { fontWeight: 600, letterSpacing: "-0.01em" },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 600 },
    subtitle2: { fontWeight: 600 },
    body1: { fontSize: "0.75rem", lineHeight: 1.6 },
    body2: { fontSize: "0.675rem", lineHeight: 1.5 },
    button: {
      textTransform: "none",
      fontWeight: 600,
      letterSpacing: "0.01em",
      fontSize: "0.6rem",
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: palette.background.default,
          scrollbarWidth: "thin",
          "&::-webkit-scrollbar": { width: 8 },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: alpha(palette.text.secondary, 0.3),
            borderRadius: 10,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: palette.background.paper,
          border: `1px solid ${palette.divider}`,
          boxShadow:
            "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
          backgroundImage: "none",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          boxShadow: "none",
          "&:hover": {
            boxShadow:
              "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
          },
        },
        containedPrimary: {
          "&:hover": { backgroundColor: palette.primary.dark },
        },
        outlined: {
          borderWidth: "1px !important",
          borderColor: alpha(palette.text.primary, 0.2),
          backgroundColor: palette.background.paper,
          "&:hover": {
            backgroundColor: alpha(palette.text.primary, 0.02),
            borderColor: alpha(palette.text.primary, 0.3),
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: palette.background.paper,
          borderRight: `1px solid ${palette.divider}`,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          borderRadius: 6,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 600,
          color: palette.text.secondary,
          backgroundColor: alpha(palette.background.default, 0.5),
        },
      },
    },
  },
});
